interface TopLevelData {
  name: string
  mean: string
  std: string
  location: string
}

export const topLevelData: TopLevelData[] = [
  {
    name: 'DB Time(total)',
    mean: 'Database_time:total.values.mean',
    std: 'Database_time:total.values.std',
    location: 'Performance Overview --> Database Time by SQL Type'
  },
  {
    name: 'QPS(total)',
    mean: 'QPS:total.values.mean',
    std: 'QPS:total.values.std',
    location: 'TiDB-Details --> Query Summary --> QPS(total)'
  },
  {
    name: 'Transaction OPS(total)',
    mean: 'TPS:total.values.mean',
    std: 'TPS:total.values.std',
    location: 'TiDB-Details --> Transaction --> Transaction OPS(total)'
  },
  {
    name: 'Query Duration(p99)',
    mean: 'P99_query_duration_all:total.values.mean',
    std: 'P99_query_duration_all:total.values.std',
    location:
      'Dev Tier TiDB in One Screen --> TiDB Usage --> Query Duration(p99)'
  },
  {
    name: 'Transaction Duration(p99)',
    mean: 'P99_transaction_duration:total.values.mean',
    std: 'P99_transaction_duration:total.values.std',
    location:
      'Dev Tier TiDB in One Screen --> TiDB Usage --> Transaction Duration(p99)'
  },
  {
    name: 'TiKV Storage Used Size(for all mirrors)',
    mean: 'TiKV_storage_size:total.values.mean',
    std: 'TiKV_storage_size:total.values.std',
    location: 'TiDB in One Screen --> Overview --> TiKV Storage Size'
  },
  {
    name: 'TiKV Storage Capacity',
    mean: 'TiKV_storage_capacity:total.values.mean',
    std: 'TiKV_storage_capacity:total.values.std',
    location: 'TiDB in One Screen --> Overview --> TiKV Storage Capacity'
  },
  {
    name: 'TiFlash storage used size(for all mirrors)',
    mean: 'TiFlash_storage_size:total.values.mean',
    std: 'TiFlash_storage_size:total.values.std',
    location: 'TiDB in One Screen --> Overview --> TiFlash storage Size'
  },
  {
    name: 'TiFlash Storage Capacity',
    mean: 'TiFlash_storage_capacity:total.values.mean',
    std: 'TiFlash_storage_capacity:total.values.std',
    location: 'TiDB in One Screen --> Overview --> TiFlash storage Capacity'
  },
  {
    name: 'Region Count Per TiKV',
    mean: 'region_count_per_tikv:total.values.mean',
    std: 'region_count_per_tikv:total.values.std',
    location: 'TiKV-Details --> Cluster --> Region'
  },
  {
    name: 'Total number of tables/partitions',
    mean: 'table_count_by_sum_stats_healthy:total.values.mean',
    std: 'table_count_by_sum_stats_healthy:total.values.std',
    location: `[manual] estimated by TiDB-Details --> Statistics --> Stats Healthy Distribution or Dashboard ---> Debug Data > Schema Info`
  },
  {
    name: 'Size of the largest table/partition',
    mean: '[manual]',
    std: '[manual]',
    location: '[manual] query information_schema.tables'
  },
  {
    name: `Table/partition's average row length`,
    mean: '[manual]',
    std: '[manual]',
    location: '[manual] query information_schema.tables'
  },
  {
    name: 'Internal SQL OPS(total)',
    mean: 'internal_QPS:total.values.mean',
    std: 'internal_QPS:total.values.std',
    location: 'TiDB-Details --> Query Details --> Internal SQL OPS'
  }
]
